import { Box, Spacer } from '@jfs/ui-new'
import { useState, useEffect } from 'react';
import { AepsButton } from '../../comps/AepsButton'
import { Container } from '../../comps/Container'
import { OtpTextInput } from '../../comps/OtpTextInput'
import { ResendOtp } from '../../comps/ResendOtp'
import { SubTitle } from '../../comps/SubTitle'
import { Title } from '../../comps/Title'
import { useStores } from '../../data/store'

interface EnterOtpCompProps {
  onOtpSubmit: any
  isLoading: boolean
  title: string
  subTitle: string
  buttonTitle: string
  onResendOTPPress: any
  resendOtpState: any
}

export const EnterOtpComp = ({
  onOtpSubmit,
  isLoading,
  title,
  subTitle,
  buttonTitle,
  onResendOTPPress,
  resendOtpState,
}: EnterOtpCompProps) => {
  const [otp, setOtp] = useState('')
  const { setMessage } = useStores((root) => ({
    setMessage: root.message.setMessage,
  }))

  useEffect(() => {
    if (resendOtpState === 'fulfilled') {
      setMessage('OTP resended successfully.', 'POSITIVE')
      setOtp('')
    }
  }, [resendOtpState, setMessage])

  return (
    <Container showFooter={true}>
      <Title title={title} />
      <Spacer size={8} />
      <SubTitle subTitle={subTitle} />
      <Spacer size={48} />
      <Box flex={1} alignItems="center">
        <OtpTextInput fieldName="otp" value={otp} setFieldValue={(_, val: any) => setOtp(val)} />

        <ResendOtp onResendOTPPress={onResendOTPPress} showLoader={resendOtpState === 'pending'} />
      </Box>
      <AepsButton
        title={buttonTitle}
        onPress={() => onOtpSubmit(otp)}
        disabled={otp.length != 6}
        isLoading={isLoading}
      />
    </Container>
  )
}
